/**
 * Import global styles.
 */
 import './styles/style.scss';
 import './styles/editor.scss';
//  import './styles/variables.scss'